import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { PreviewOrdersActions } from '../actions';
import { OrderService } from '@app/services/order/order.service';

@Injectable()
export class PreviewOrdersEffects {
  constructor(
    private store: Store,
    private actions$: Actions,
    private orderService: OrderService,
  ) {}

  loadCountReadyOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PreviewOrdersActions.loadPreviewOrders),
      exhaustMap(({ queryParameters }) => {
        return this.orderService.getPreviewOrders(queryParameters, true).pipe(
          map(({ orders, count }) => {
            return PreviewOrdersActions.loadPreviewOrdersSuccess({
              orders,
              count,
            });
          }),
          catchError(() => {
            return of(PreviewOrdersActions.loadPreviewOrdersFailure());
          }),
        );
      }),
    ),
  );

  loadPreviewOrdersCount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PreviewOrdersActions.loadPreviewOrdersCount),
      exhaustMap(({ queryParameters }) => {
        return this.orderService.getPreviewOrdersCount(queryParameters, true).pipe(
          map(({ count }) => {
            return PreviewOrdersActions.loadPreviewOrdersCountSuccess({
              count,
            });
          }),
          catchError(() => {
            return of(PreviewOrdersActions.loadPreviewOrdersCountFailure());
          }),
        );
      }),
    ),
  );
}
